
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trade/sent",
      function () {
        return require("private-next-pages/trade/sent/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trade/sent"])
      });
    }
  